import React from "react";
import { ChevronBlue } from "@speedoc/design-assets/build/icons";

export default function MobileServiceCard({ title, description, symbol, isAnimated }) {
  return (
    <div className={`mobileServiceCard ${isAnimated ? "animated" : ""}`}>
      <div className="symbol">{symbol}</div>

      <div className="content">
        <div className="title">{title}</div>
        <div className="description">{description}</div>
      </div>

      <div className="icon">
        <ChevronBlue />
      </div>
    </div>
  );
}
